import useFetcher from 'hooks/useFetcher/useFetcher';
import { ServiceTypes } from 'hooks/useFetcher/interfaces';
import { stringifyUrl, getRequest } from 'utils';
import { Properties } from 'types';

export const useExpensesAPI = (): Properties => {
  const fetcher = useFetcher(ServiceTypes.CRM);

  return {
    getExpenses: ({ queryKey: [, query] }) => {
      return fetcher(stringifyUrl(`/expenses`, query), getRequest);
    },
    postExpenses: (data) => {
      return fetcher('/expenses', {
        data,
        request: {
          method: 'POST',
        },
      });
    },
  };
};
